module.exports = __webpack_public_path__ + "static/grid_hyzx.eb9ec8fd.png";